import { NgModule } from '@angular/core';
import { TranslatedNamePipeModule } from 'src/app/pipes/translated-name/translated-name-pipe.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SharedModule } from 'src/app/components/shared/shared.module';
import { PosManagerMenuModule } from 'src/app/components/pos-manager/menu/pos-manager.module';
import { RealtimeInfoMenuPage } from './realtime-info-menu.page';
import { TotalSaleByCategoryPage } from './total-sale-by-category/total-sale-by-category.page';
import { ManagerHeaderComponentModule } from '../../../components/pos-manager/header/manager-header-component.module';
import { DatepickerComponentModule } from '../../../components/shared/datepicker/datepicker-component.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RealtimeTypeDisplayPipeModule } from '../../../pipes/payment-type-display/realtime-type-display-pipe.module';
import { MostPopularItemsComponentModule } from '../../../components/pos-manager/most-popular-items/most-popular-items.component.module';
import { ObjectKeysPipeModule } from '../../../pipes/object-keys/object-keys-pipe.module';
import { PosOperatorsPage } from './pos-operators/pos-operators.page';
import { SumTotalTicketsPipeModule } from '../../../pipes/sum-total-tickets-pipe/sum-total-tickets-pipe.module';
import { SortIconPipeModule } from '../../../pipes/sort-icon/sort-icon-pipe.module';
import { OperatorSortPipeModule } from '../../../pipes/operator-sort/operator-sort-pipe.module';
import { CategorySortPipeModule } from '../../../pipes/category-sort/category-sort-pipe.module';
import { CategoryTotalPipeModule } from '../../../pipes/category-total/category-total-pipe.module';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoSelectDirectiveModule } from 'src/app/directives/transloco-select/transloco-select.module';

@NgModule({
  declarations: [
    RealtimeInfoMenuPage,
    TotalSaleByCategoryPage,
    PosOperatorsPage
  ],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: RealtimeInfoMenuPage
      },
      {
        path: 'total-sale-by-category',
        component: TotalSaleByCategoryPage
      },
      {
        path: 'pos-operators',
        component: PosOperatorsPage
      }
    ]),
    CommonModule,
    TranslatedNamePipeModule,
    IonicModule,
    SharedModule,
    PosManagerMenuModule,
    ManagerHeaderComponentModule,
    DatepickerComponentModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RealtimeTypeDisplayPipeModule,
    ObjectKeysPipeModule,
    MostPopularItemsComponentModule,
    SumTotalTicketsPipeModule,
    SortIconPipeModule,
    OperatorSortPipeModule,
    CategorySortPipeModule,
    CategoryTotalPipeModule,
    TranslocoModule,
    TranslocoSelectDirectiveModule
  ]
})
export class RealtimeInfoMenuModule {}
